import { __awaiter, __decorate, __extends, __generator, __metadata, __param } from "tslib";
import { AtMessageRepository } from '../repository/at-message-repository';
import { DocMentionItem } from '../value-object/mention-item';
import { MyMentionItem } from '../value-object/my-mention-item';
import { Aggregate } from '../../base/ddd-types/aggregate';
import { dataFieldNamingHandler, exceptionHandler, parseArrayData, parseArrayDataInObject, } from '../../base/decorators';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { getVfWebQQ } from '../../base/utils';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { Emitter } from '@tencent/ark-utils/lib/event';
// CGI 返回的 JSON OBJECT 的一级目标字段
var JSONOBJECT_MENTIONS_PROPERTY_KEY = 'mentions';
// CGI 返回的 JSON OBJECT 的二级目标字段
var JSONOBJECT_RESULT_PROPERTY_KEY = 'result';
// AT 人列表的实例属性字段
var DOCLIST_PROPERTY_KEY = 'atUserList';
// AT 我的列表的实例属性字段
var MYLIST_PROPERTY_KEY = 'atMeUserList';
var AtMessageAggregate = /** @class */ (function (_super) {
    __extends(AtMessageAggregate, _super);
    function AtMessageAggregate(id, docMetaDomainService, networkRequestService) {
        var _this = _super.call(this, id) || this;
        _this.docMetaDomainService = docMetaDomainService;
        _this.networkRequestService = networkRequestService;
        _this.atMeUserList = [];
        _this.atUserList = [];
        _this.onAtUserListUpdatedEmitter = new Emitter();
        _this.onAtMeUserListUpdatedEmitter = new Emitter();
        _this.onAtUserListUpdated = _this.onAtUserListUpdatedEmitter.event;
        _this.onAtMeUserListUpdated = _this.onAtMeUserListUpdatedEmitter.event;
        _this.atMessageRepository = new AtMessageRepository(docMetaDomainService, networkRequestService);
        return _this;
    }
    AtMessageAggregate.prototype.getDocMentionList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.atMessageRepository.getDocMentionList()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AtMessageAggregate.prototype.getMyMentionList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.atMessageRepository.getMyMentionList()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AtMessageAggregate.prototype.addMention = function (mentions) {
        return __awaiter(this, void 0, void 0, function () {
            var vfwebqq;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vfwebqq = getVfWebQQ();
                        return [4 /*yield*/, this.atMessageRepository.addMention(mentions, vfwebqq)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AtMessageAggregate.prototype.deleteMention = function (mentions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.atMessageRepository.deleteMention(mentions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AtMessageAggregate.prototype.clearMentionMarks = function (mentions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.atMessageRepository.mentionReadReport(mentions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    __decorate([
        parseArrayDataInObject(DocMentionItem.prototype.constructor, DOCLIST_PROPERTY_KEY, JSONOBJECT_RESULT_PROPERTY_KEY, JSONOBJECT_MENTIONS_PROPERTY_KEY),
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AtMessageAggregate.prototype, "getDocMentionList", null);
    __decorate([
        parseArrayData(MyMentionItem.prototype.constructor, MYLIST_PROPERTY_KEY, JSONOBJECT_MENTIONS_PROPERTY_KEY),
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AtMessageAggregate.prototype, "getMyMentionList", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], AtMessageAggregate.prototype, "addMention", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], AtMessageAggregate.prototype, "deleteMention", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], AtMessageAggregate.prototype, "clearMentionMarks", null);
    AtMessageAggregate = __decorate([
        __param(1, IDocMetaDomainService),
        __param(2, INetworkRequestService),
        __metadata("design:paramtypes", [String, Object, Object])
    ], AtMessageAggregate);
    return AtMessageAggregate;
}(Aggregate));
export { AtMessageAggregate };
